<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList" :CustomerId="CustomerId"
    ></Create>
    <!-- <Edit :CustomerId="CustomerId"
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editPrice="selectedPrice"
    ></Edit> -->
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="checkRightStatus(2)"
        title="Price List"
        @add="add"
      />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="priceList"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.Product.name }}</td>
            <td class="text-left">{{ item.price | currency }}</td>
            <td class="justify-end align-center text-right">
              <v-btn  v-if="checkRightStatus(10)"
                    @click="deletePayee(item)" icon>
                    <v-icon>delete</v-icon>
                  </v-btn>
              <!-- <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    v-if="checkRightStatus(18)"
                    @click="editPayee(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(10)"
                    @click="deletePayee(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu> -->
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import customerPriceService from "@/modules/Customer/CustomerPrice/service.js";
import { mapGetters } from "vuex";

const Create = () => import("@/modules/Customer/CustomerPrice/components/Create.vue");

export default {
  name: "customer-price-list",
  props: ['CustomerId'],
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedPrice: null,
      headers: [
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "Product.name",
          sortable: true,
        },
        {
          text: "Price",
          align: "left",
          value: "Product.price",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      priceList: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "balance",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  components: {
    Create,
  },
  watch: {
    CustomerId: {
      immediate: true,
      handler() {
        this.getList();
      }
    }
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    add() {
      this.createDialog = true;
    },
    getList() {
      this.loading = true;
      (this.editDialog = false), (this.createDialog = false);
      return customerPriceService.getAll({CustomerId: this.CustomerId}).then((response) => {
        console.log('response', response)
        this.loading = false;
        this.priceList = response.data;
        return response;
      });
    },
    // editPayee(payee) {
    //   this.selectedPrice = payee;
    //   this.editDialog = !this.editDialog;
    // },
    deletePayee(payee) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          customerPriceService.delete(payee.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Customer Price has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
